<template>
  <button
    class="mdc-fab mdc-fab--extended button"
    :class="{ 'will-fly': willPlaneFly }"
    aria-label="Favorite"
    @click="$listeners.click"
  >
    <span class="mdc-fab__label">分析</span>
    <md-icon class="mdc-fab__icon"
      ><font-awesome-icon class="icon" icon="paper-plane"
    /></md-icon>
  </button>
</template>

<script>
export default {
  props: {
    willPlaneFly: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
// TODO Vue Materialのテーマ色を使う
$mdc-theme-secondary: #448aff;
@import '@material/fab/mdc-fab';

.icon {
  color: #fff;
  margin-right: 8px;
}

.button.will-fly:hover {
  .icon {
    transition: transform 0.4s ease-out;
    transform: translate(200%, -20px);
  }
}
</style>
